import React from "react";
import "./ValidationErrorToastContent.scss";

/**
 * Renders parsed validation errors. Height fits content; scrolls only if content exceeds max (e.g. 70vh).
 * @param {{ rawLine: string }[]} items - from parseValidationErrorMessage()
 * @param {number|string} maxHeight - optional max height (e.g. 420 or "70vh"); content grows up to this then scrolls
 * @param {"error"|"warning"} variant - "error" (red bullet) or "warning" (yellow bullet)
 */
const ValidationErrorToastContent = ({ items = [], maxHeight, variant = "error" }) => {
  if (!items.length) return null;

  const style = maxHeight != null
    ? { maxHeight: typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight }
    : {};

  const modifier = variant === "warning" ? "validation-error-toast--warning" : "";

  return (
    <div className={`validation-error-toast validation-error-toast--fit-content ${modifier}`.trim()} style={style}>
      <ul className="validation-error-toast__list">
        {items.map((item, index) => {
          const line = typeof item === "string" ? item : item.rawLine;
          return (
            <li key={`opt-${index}`} className="validation-error-toast__line">
              <span className="validation-error-toast__bullet" aria-hidden />
              <span className="validation-error-toast__line-text">
                {line ?? ""}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ValidationErrorToastContent;
